import { useLocalStorageState } from "ahooks";
import { take } from "lodash";
import { useCallback } from "react";

const SEARCH_HISTORY_KEY = "hb_search_history";

/**
 * 搜索历史hook封装，自动同步到localStorage，最多存储10条
 * @returns searchHis 搜索历史
 * @returns addSearchHistory 添加搜索历史
 * @returns clearSearchHistory 清空搜索历史
 */
const useSearchHistory = () => {
  const [searchHis, setSearchHis] = useLocalStorageState(SEARCH_HISTORY_KEY, {
    defaultValue: [],
  });

  const addSearchHistory = useCallback(
    (value: string) => {
      if (!value) return;
      const newHis = take([...new Set([value, ...searchHis])], 20);
      setSearchHis(newHis);
    },
    [searchHis, setSearchHis]
  );

  const clearSearchHistory = useCallback(() => {
    setSearchHis([]);
  }, [setSearchHis]);

  return {
    searchHis,
    addSearchHistory,
    clearSearchHistory,
  };
};

export default useSearchHistory;
